import { createContext } from 'react';
export default createContext<{ [key: string]: boolean }>({});
